import React, {useEffect,useState,useContext,useRef,forwardRef,useImperativeHandle} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import FileImage from './FileImage';
import { PiImageThin } from 'react-icons/pi';
import { formatDate,saveNewsItem,useNewsNavigation, X_PADDING } from '../constants';
import { createRoot } from 'react-dom/client'
import Edit from './Edit';
import NewsForm from './NewsForm';
import client from '../client';
import { Logo } from './CoazIcons';
import { PiPencilSimple,PiTrashLight } from 'react-icons/pi';

const NewsItem = ({newsItem,size}) => {
    const {editing,version, setVersion} = useContext(GlobalContext);
    const editRef = useRef();
    const {newsItemReadMore} = useNewsNavigation();

    const onEdit = (item) => {
        const container = document.createElement("div");
        container.style.left = '0';
        container.style.top = '0';
        container.style.right = '0';
        container.style.bottom = '0'; 
        container.style.position = 'fixed';
        container.style.zIndex = 100;
        container.style.overflow = 'hidden';
        document.body.appendChild(container);

        // Create a new React root
        const root = createRoot(container);

        // Submit
        const onSubmit = async () => {
            return await saveNewsItem(editRef);
        }

        // Define cleanup function
        const close = () => {
            root.unmount();
            container.remove();
            
        };
        // Render the component into the container
        root.render(<Edit 
            title="Edit News Item"
            Dialog={() => <NewsForm newsItem={item} ref={editRef}/>} 
            submit={onSubmit} 
            close={close} 
            version={version} 
            setVersion={setVersion}/>);
    }

    const onDelete = (item) => {
        if(!item || !item.ref || !item.ref.id) return;

        const container = document.createElement("div");
        container.style.left = '0';
        container.style.top = '0';
        container.style.right = '0';
        container.style.bottom = '0'; 
        container.style.position = 'fixed';
        container.style.zIndex = 100;
        container.style.overflow = 'hidden';
        document.body.appendChild(container);

        // Create a new React root
        const root = createRoot(container);

        const {request,errorMessage} = client;

        // Submit
        const onSubmit = async () => {
            try {
                await request("DELETE",`news-items/${item.ref.id}`);
                return {message:'Successful', success:true}
            } catch (error) {
                return {message:errorMessage(error)};
            }
        }

        // Define cleanup function
        const close = () => {
            root.unmount();
            container.remove();
            
        };
        // Render the component into the container
        root.render(<Edit 
            title="Delete News Item"
            Dialog={() => <p>Are you sure you want to delete this item?</p>} 
            submit={onSubmit} 
            close={close} 
            version={version} 
            setVersion={setVersion}/>);
    }
  return (
      <div style={{width:size?size.width+'px':'100%'}} 
            className='flex flex-col border border-[#eef1f4] rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow'>
            <div style={{height:size?((9*size.width)/16)+'px':'275px'}} className='relative w-full h-auto object-cover'>
                {newsItem.date && newsItem.date instanceof Date && !isNaN(newsItem.date) &&
                    <div className="absolute top-0 right-0 bg-[#55a2dc] w-16 h-16 rounded-lg flex flex-col items-center justify-center shadow-lg">
                        <span className="text-white text-xl font-bold">{newsItem.date.getFullYear()}</span>
                        <span className="text-white/80 text-[10px] font-semibold uppercase tracking-wider">
                            {`${newsItem.date.getDate()} ${newsItem.date.toLocaleString('default', { month: 'short' })}`}
                        </span>
                    </div>
                }
                {/* {newsItem.file?
                    <FileImage 
                        file={newsItem.file} 
                        alt="preview"
                        className='w-full h-full object-cover'/>
                    :
                    <div className='w-full h-full bg-theme p-4'>
                        <Logo  fill={"rgb(255,255,255)"}/>
                    </div>
                } */}
				{newsItem.loading ? (
					<div className='flex items-center justify-center w-full h-full bg-theme'>
						<div className='w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin' />
					</div>
				) : newsItem.file ? (
					<FileImage
						file={newsItem.file}
						alt={newsItem.name}
						className='w-full h-full object-cover'
					/>
				) : (
					<div className='w-full h-full bg-theme p-4'>
						<Logo fill={"rgb(255,255,255)"} />
					</div>
				)}
                {editing &&
                    <div className='absolute flex flex-row right-0 bottom-0 p-2 space-x-2'>
                        <button onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onEdit(newsItem);
                            
                        }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                            <PiPencilSimple size={16}/>
                        </button>
                        <button onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onDelete(newsItem);
                        }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                            <PiTrashLight size={16}/>
                        </button>
                    </div>
                }
            </div>
            <div className="w-full p-4">
                <p className="font-bold text-[#16365c] text-sm mb-2 w-full max-h-10 line-clamp-2">{newsItem.name}</p>
                <p className="text-[#7c8a97] text-xs mb-3 w-full max-h-16 line-clamp-3">{newsItem.description}</p>
                <button onClick={(e) => {
                    e.preventDefault();
                    newsItemReadMore(newsItem);
                }} className="text-[#1477c2] text-xs font-semibold hover:text-[#16365c] transition">
                    Read More →
                </button>
            </div>
      </div>
  )
}

export default NewsItem